import React, { useMemo } from 'react'
import { IcoMoon, VehicleUniversalFitIcon, PowersportUniversalFitIcon } from '@usap/uicomponents'
import {
  StyledFitmentInfoContainer,
  StyledIconContainer,
  StyledUniversalFit,
  StyledFitmentVehicle,
  StyledUniversalFitWrapper,
} from '../VehicleFitmentWmo.css'

const UniversalFitWmo = ({ vehicle, isPowersport }) => {
  const testid = vehicle ? 'universal-fit-with-vehicle' : 'universal-fit-without-vehicle'
  const icon = useMemo(() => {
    if (isPowersport) {
      return PowersportUniversalFitIcon
    }
    return VehicleUniversalFitIcon
  }, [isPowersport])

  return (
    <StyledUniversalFitWrapper data-testid={testid}>
      <StyledIconContainer>
        <IcoMoon
          icon={icon}
        />
      </StyledIconContainer>
      <StyledFitmentInfoContainer>
        <StyledUniversalFit>
          Universal Fit &nbsp;
      </StyledUniversalFit>
        <StyledFitmentVehicle>
          {vehicle}
        </StyledFitmentVehicle>
      </StyledFitmentInfoContainer>
    </StyledUniversalFitWrapper>
  )
}

export default UniversalFitWmo
